import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PROD_COLOR, WAIT_COLOR, MACHINE_COLOR, LINE_HEIGHT } from './plan-overview-dialog.types';

const PlanOverviewLegend: FC = () => {
    const { t: translate } = useTranslation(['orders']);

    const items = [
        { color: PROD_COLOR, label: translate('orders:PRODUCTION') },
        { color: WAIT_COLOR, label: translate('orders:WAITING_FOR_MACHINE') },
        { color: MACHINE_COLOR, label: translate('orders:MACHINE_HOURS') },
    ];

    return (
        <Box display="flex" gap={3} mb={1}>
            {items.map(({ color, label }) => (
                <Box key={label} display="flex" alignItems="center" gap={0.75}>
                    <Box sx={{ width: 24, height: LINE_HEIGHT, backgroundColor: color, borderRadius: 1 }} />
                    <Typography variant="caption">{label}</Typography>
                </Box>
            ))}
        </Box>
    );
};

export default PlanOverviewLegend;
